import React from 'react'
import BreadCrumb from '../BreadCrumb'
import "../../../../../../styles/ambassadorChallenge/manageChallenge.scss";
import CurrentChallengeSummary from '../CurrentChallengeSummary';
import Leaderboard from './Leaderboard';
import ReferralTracking from './ReferralTracking';
import RewardDistribution from './RewardDistribution';
// import { useAmbassadorChallengeContext } from 'contexts/AmbassadorChallengeContext';
import { useAmbassadorChallengeContext } from "../../../../../../contexts/AmbassadorChallengeContext";

function ManageChallenge() {

  const { tab, setTab } = useAmbassadorChallengeContext()

  return (
    <section className='mainContainer'>
       <BreadCrumb />

       <div className='tabs'>
        <button className={tab==='leaderboard' ? 'activeBtn' : ''}
        onClick={()=>setTab('leaderboard')}
        >Leaderboard</button>
        <button className={tab==='referralTracking' ? 'activeBtn' : ''}
        onClick={()=>setTab('referralTracking')}
        >Referral Tracking</button>
        <button className={tab==='rewardDistribution' ? 'activeBtn' : ''}
        onClick={()=>setTab('rewardDistribution')}
        >Reward Distribution</button>
       </div>

      {tab==='leaderboard' && <CurrentChallengeSummary />}
      {tab==='leaderboard' && <Leaderboard />}
      {tab==='referralTracking' && <ReferralTracking />}
      {tab==='rewardDistribution' && <RewardDistribution />}
    </section>
  )
}

export default ManageChallenge